import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { $PoiInfo } from 'shared/atoms';
import { useTranslation } from 'react-i18next';
import LocationIcon from '@lemon8/design/lib/icons/icon_assets/location.svg';
import PhoneIcon from '@lemon8/design/lib/icons/icon_assets/phone.svg';
import DividerContainer from '~/components/divider-container';
import { ClickPosition } from '~/utils/click-position';
import useReflowClick from '~/utils/use-reflow-click';
import { ELEMENT_TIMING_FMP } from '@lemon8/web-app-shared/component';

import './style.scss';

export default function HashtagDescriptionSection(): JSX.Element {
  const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();
  const { t } = useTranslation();
  const {
    name,
    tel: phoneNumber,
    id: google_id,
    formatted_address,
    formatted_address_without_post_country_asc,
  } = useAtomValue($PoiInfo(poiId));

  const formattedAddress = formatted_address || formatted_address_without_post_country_asc;

  const handleLocationClick = useReflowClick(
    {
      clickEvent: (_, bundle) => ({
        ...bundle,
        current_position: ClickPosition.related_address,
      }),
      defaultBehavior: () => {
        const query = encodeURI(formatted_address);
        window.open(`https://www.google.com/maps/search/?api=1&query=${query}&query_place_id=${google_id}`);
      },
    },
    [formatted_address],
  );

  const handlePhoneClick = useReflowClick(
    {
      clickEvent: (_, bundle) => ({
        ...bundle,
        current_position: ClickPosition.related_phone,
      }),
      defaultBehavior: () => {
        window.location.href = `tel:${phoneNumber}`;
      },
    },
    [phoneNumber],
  );

  return (
    <section id="poi-description-section">
      <h1 elementtiming={ELEMENT_TIMING_FMP}>{name}</h1>
      {formattedAddress && (
        <div className="poi-details">
          <p>{formattedAddress || t('poi_no_address_information')}</p>
          <DividerContainer wrapperCls="poi-details-actions" dividerCls="poi-details-actions-divider">
            {formattedAddress && (
              <div onClick={handleLocationClick}>
                <LocationIcon />
              </div>
            )}
            {phoneNumber && (
              <div onClick={handlePhoneClick}>
                <PhoneIcon />
              </div>
            )}
          </DividerContainer>
        </div>
      )}
    </section>
  );
}
